import { createColumnHelper } from '@tanstack/react-table';

import { History } from 'types/history';
import { Site } from 'types/site';
import { Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';
import getSiteNameBySiteID from 'utils/getSiteNameBySiteID';

const col = createColumnHelper<History>();

const showVenue = (history: History, allSites: Site[]) => {
  if (history) {
    return getSiteNameBySiteID((history as any)?.package?.site, allSites);
  }

  return ' - ';
};

export const buildPackagesHistoryColumns = (allSites: Site[]) => [
  col.accessor((history) => (history as any)?.package?.orderId || '-', {
    id: 'orderId',
    header: 'Order id',
    minSize: 180,
  }),
  col.accessor((history) => (history as any)?.package?.items?.[0]?.sku, {
    id: 'itemSku',
    header: 'Item SKU',
    minSize: 180,
  }),
  col.accessor((history) => (history as any)?.caseSku?.name || '-', {
    id: 'caseSku',
    header: 'Case SKU',
    minSize: 150,
  }),
  col.accessor((history) => (history as any)?.package?.items?.length || '-', {
    id: 'itemsCount',
    header: 'Items count',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor(
    (history) => convertUTCToLocal((history as any)?.package?.createdAt, true),
    { id: 'created', header: 'Created', minSize: 150 },
  ),
  col.accessor((history) => Status[history?.status] || '-', {
    id: 'status',
    header: 'Status',
    minSize: 110,
    meta: { align: 'center' },
  }),
  col.accessor(
    (history) => convertUTCToLocal((history as any)?.package?.updatedAt, true),
    { id: 'updated', header: 'Updated', minSize: 150 },
  ),
  col.accessor(
    (history) =>
      `${history?.scanPerformedBy?.fname || '-'} ${
        history?.scanPerformedBy?.lname || ''
      }`,
    { id: 'scanPerformedBy', header: 'Scan Performed by', minSize: 200 },
  ),
  col.accessor((history) => showVenue(history, allSites), {
    id: 'venue',
    header: 'Last Venue',
    minSize: 150,
    meta: { align: 'center' },
  }),
];
